import api from "./client";

export async function listModbusHosts(siteId) {
  if (!siteId) return [];
  const { data } = await api.get(`/modbus/hosts/site/${siteId}`);
  return data || [];
}

export async function saveModbusHosts(siteId, items) {
  const { data } = await api.put(`/modbus/hosts/site/${siteId}`, {
    items: items || [],
  });
  return data || [];
}

export async function listSignalRegisters(siteId) {
  if (!siteId) return [];
  const { data } = await api.get(`/modbus/registers/site/${siteId}`);
  return data || [];
}

export async function saveSignalRegisters(siteId, items) {
  const { data } = await api.put(`/modbus/registers/site/${siteId}`, {
    items: items || [],
  });
  return data || [];
}

export async function listModbusMappings(siteId) {
  if (!siteId) return [];
  const { data } = await api.get(`/modbus/map/site/${siteId}`);
  return data || [];
}

export async function saveModbusMappings(siteId, items) {
  const { data } = await api.put(`/modbus/map/site/${siteId}`, {
    items: items || [],
  });
  return data || [];
}

export async function fetchModbusStatus() {
  const { data } = await api.get("/modbus/sites/status");
  return data || [];
}

export async function setSitePollingInterval(siteId, pollIntervalS) {
  const { data } = await api.post(`/modbus/site/${siteId}/poll-interval`, {
    poll_interval_s: pollIntervalS,
  });
  return data;
}

export async function fetchSiteLatestValues(siteId) {
  const { data } = await api.get(`/modbus/site/${siteId}/last-data`);
  return data || [];
}

export async function fetchTrackerStatus(siteId) {
  if (!siteId) return null;
  const { data } = await api.get(`/modbus/site/${siteId}/tracker-status`);
  return data;
}

export async function startModbusWorker(siteId) {
  const { data } = await api.post(`/modbus/workers/start/${siteId}`);
  return data;
}

export async function stopModbusWorker(siteId) {
  const { data } = await api.post(`/modbus/workers/stop/${siteId}`);
  return data;
}

export async function fetchModbusAnalyticsDates(siteId) {
  if (!siteId) return { dates: [] };
  const { data } = await api.get(`/modbus/site/${siteId}/analytics/dates`);
  return data;
}

export async function fetchModbusAnalytics(siteId, date) {
  if (!siteId || !date) return null;
  const params = new URLSearchParams({ date });
  const { data } = await api.get(`/modbus/site/${siteId}/analytics?${params.toString()}`);
  return data;
}
